import { useState } from 'react'
import {Menu, X} from 'lucide-react'

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Tokenomics', href: '#tokenomics' },
    { label: 'Moonmap', href: '#roadmap' },
    { label: 'Ecosystem', href: '#ecosystem' },
    { label: 'Community', href: '#community' },
  ]

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-red-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              src="https://static.lumi.new/a1/a17bbbd6146ddf5f97d0afdf148dba2d.webp"
              alt="Rocket Bunny"
              className="h-14 w-auto hover:scale-110 transition-transform duration-300"
            />
          </div>

          {/* Desktop Menu - Hamburger */}
          <div className="flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-red-500 transition-colors p-2"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="h-8 w-8" />
              ) : (
                <Menu className="h-8 w-8" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile/Desktop Menu Dropdown */}
      {isMenuOpen && (
        <div className="bg-black border-t border-red-600/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col space-y-2">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white hover:text-red-500 px-4 py-3 text-lg font-semibold border-2 border-red-600 hover:bg-red-600/10 transition-all duration-300 rounded"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
